var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBlockplayerUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 4a1 1 0 011 1v4.2l5.213-3.65a.5.5 0 01.787.41v12.08a.5.5 0 01-.787.41L17 14.8V19a1 1 0 01-1 1H2a1 1 0 01-1-1V5a1 1 0 011-1h14zM9 8l-4 4h3v4h2v-4h3L9 8z"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCIgd2lkdGg9IjI0IiBoZWlnaHQ9IjI0Ij48cGF0aCBmaWxsPSJub25lIiBkPSJNMCAwSDI0VjI0SDB6Ii8+PHBhdGggZD0iTTE2IDRjLjU1MiAwIDEgLjQ0OCAxIDF2NC4ybDUuMjEzLTMuNjVjLjIyNi0uMTU4LjUzOC0uMTAzLjY5Ny4xMjQuMDU4LjA4NC4wOS4xODQuMDkuMjg2djEyLjA4YzAgLjI3Ni0uMjI0LjUtLjUuNS0uMTAzIDAtLjIwMy0uMDMyLS4yODctLjA5TDE3IDE0LjhWMTljMCAuNTUyLS40NDggMS0xIDFIMmMtLjU1MiAwLTEtLjQ0OC0xLTFWNWMwLS41NTIuNDQ4LTEgMS0xaDE0ek05IDhsLTQgNGgzdjRoMnYtNGgzTDkgOHoiLz48L3N2Zz4=";
export { SvgBlockplayerUpload as ReactComponent };